import type { AppRoutes } from "@for-it/web-lib";
import AdminPanelLayout from "./layouts/admin-panel-layout/admin-panel-layout.js";
import HomeLayout from "./layouts/home.js";

export const Routes = {
    HOME: {
        path: () => "/",
        layout: AdminPanelLayout,
        isAuthRequired: true,
    },
    LOGIN: {
        path: () => "/login",
        layout: HomeLayout,
    },
    RECOVER_PASSWORD: {
        path: () => "/recover-password",
        layout: HomeLayout,
    },
    SET_NEW_PASSWORD: {
        path: () => "/set-new-password",
        layout: HomeLayout,
    },
    TENANTS_LIST: {
        path: () => "/tenants",
        layout: AdminPanelLayout,
        isAuthRequired: true,
    },
    TENANTS_CREATE: {
        path: () => "/tenants/create",
        layout: AdminPanelLayout,
        isAuthRequired: true,
    },
    CHANGE_PASSWORD: {
        path: () => "/profile",
        layout: AdminPanelLayout,
        isAuthRequired: true,
    },
} as const satisfies AppRoutes;

export type Routes = typeof Routes;
